export default __webpack_public_path__ + "static/media/NicePng_watsapp-icon-png_9332131.3ad98a37.png";